import { useEffect, useState } from 'react';
import { useHistory } from "react-router-dom";
import { observer, inject } from "mobx-react";

import SvgsCommons from "@/components/svgs/commons";
import SubGif from '@/static/images/newHome/sub.gif'
import { newPath, EmailHost } from '@/utils/index'
import { Subscribe } from './css'

const Chunk = ({ store }) => {
  const { isMobile } = store.common;

  return (
    <Subscribe className={isMobile ? 'mobile' : ''}>
      <div className="pic">
        <img src={SubGif} height={isMobile ? 100 : 220} />
      </div>
      <div className="detail">
        <h2>
          Subscribe To
          <span>Dmail</span>
        </h2>
        <p>Unlock instant updates and exclusive insights, engage with your favorite projects and earn rewards just for staying informed!</p>
        <div style={{ display: 'inline-block' }}>
          <a className="filled-red to-sub" href={`${EmailHost}/sub/DmailNetwork`} target="_blank">Subscribe<SvgsCommons type="arrow" /></a>
        </div>
      </div>
    </Subscribe>
  )
}

export default inject("store")(observer(Chunk))